/**
 * @Description
 */

import { FC, useMemo } from 'react';
import styles from './index.module.less';
import Header from '../Header';
// import PPTBarChart from '../BarChart';
import { isArray, isNotEmptyAny } from '@lhb/func';
import PPTBarLineChart from '../BarLineChart';
import PPTMap from '../Map';


const PageFour:FC<any> = ({
  rangeName,
  surroundingInfoVO,
  lnglat,
  range
}) => {

  const {
    houseInfo,
    workInfo,
    shopInfo,
    districtName,
    massData,
    isSourceByGaode
  } = useMemo(() => {
    if (!isNotEmptyAny(surroundingInfoVO)) return {};

    let houseInfo: any;
    let workInfo: any;
    let shopInfo: any;
    let massData: any;
    let isSourceByGaode = false;
    surroundingInfoVO?.fomatVOList?.map((item) => {
      switch (item?.id) {
        case 7:
          houseInfo = item?.rateList || [];
          massData = item?.storeVOList;
          isSourceByGaode = item?.dataSource === 1;
          break;
        case 8:
          workInfo = item?.rateList || [];
          break;
        case 11:
          shopInfo = item?.rateList || [];
          break;
      }
    });


    return {
      houseInfo,
      workInfo,
      shopInfo,
      districtName: isArray(surroundingInfoVO?.fomatVOList) ? surroundingInfoVO.fomatVOList[0]?.districtName : '',
      massData,
      isSourceByGaode
    };
  }, [surroundingInfoVO]);

  return (
    <div className={styles['page']}>
      <Header title={`住宅配套 — ${rangeName}`}/>

      <div className={styles['content']}>
        <div className={styles['detail']}>
          {surroundingInfoVO?.introductionHasHousePrice || ''}
        </div>

        <div className={styles['bottom']}>
          <div className={styles['bottom-left']}>
            {(isNotEmptyAny(shopInfo)) ? <div className={styles['food-chart']}>
              <PPTBarLineChart
                width={630}
                height={360}
                title='商业区数量分布'
                xAxisData={shopInfo?.map((item) => item.name)}
                seriesData={[{
                  name: '商业区类型数量',
                  type: 'bar',
                  yAxisIndex: 0,
                  splitNumber: 5,
                  data: shopInfo?.map((item) => item.num),
                  itemStyle: {
                    color: '#8B3DFF'
                  }
                }, {
                  name: `相对【${districtName}】占比`,
                  type: 'line',
                  yAxisIndex: 1,
                  splitNumber: 5,
                  data: shopInfo?.map((item) => item.rate),
                  lineStyle: {
                    color: '#00D7FF',
                    width: 4
                  },
                  itemStyle: {
                    color: '#00D7FF',
                  }
                }]}
                yAxisData={[
                  {
                    axisLabel: {
                      color: '#999999',
                      lineHeight: 22,
                      fontSize: 16,
                      fontWeight: 400
                    }
                  },
                  {
                    axisLabel: {
                      formatter: '{value}%',
                      color: '#999999',
                      lineHeight: 22,
                      fontSize: 16,
                      fontWeight: 400
                    }
                  }
                ]}
              />
            </div> : <></>}

            {isNotEmptyAny(houseInfo) ? <div className={styles['commercial-chart']}>
              <PPTBarLineChart
                width={630}
                height={360}
                title={isSourceByGaode ? '住宅区数量分布' : '住宅区户数分布'}
                xAxisData={houseInfo?.map((item) => item.name)}
                seriesData={[{
                  name: isSourceByGaode ? '住宅区类型数量' : '住宅区户数数量',
                  type: 'bar',
                  yAxisIndex: 0,
                  splitNumber: 5,
                  data: houseInfo?.map((item) => item.num),
                  itemStyle: {
                    color: '#70C8E4'
                  }
                }, {
                  name: `相对【${districtName}】占比`,
                  type: 'line',
                  yAxisIndex: 1,
                  splitNumber: 5,
                  data: houseInfo?.map((item) => item.rate),
                  lineStyle: {
                    color: '#FFC966',
                    width: 4
                  },
                  itemStyle: {
                    color: '#FFC966',
                  }
                }]}
                yAxisData={[
                  {
                    axisLabel: {
                      color: '#999999',
                      lineHeight: 22,
                      fontSize: 16,
                      fontWeight: 400
                    }
                  },
                  {
                    axisLabel: {
                      formatter: '{value}%',
                      color: '#999999',
                      lineHeight: 22,
                      fontSize: 16,
                      fontWeight: 400
                    }
                  }
                ]}
              />
            </div> : <></>}


          </div>

          <div className={styles['bottom-right']}>
            <div className={styles['other-chart']}>
              {isNotEmptyAny(workInfo) ? <PPTBarLineChart
                width={630}
                height={360}
                title='办公区数量分布'
                xAxisData={workInfo?.map((item) => item.name)}
                seriesData={[{
                  name: '办公区类型数量',
                  type: 'bar',
                  yAxisIndex: 0,
                  splitNumber: 5,
                  data: workInfo?.map((item) => item.num),
                  itemStyle: {
                    color: '#979EFF'
                  }
                }, {
                  name: `相对【${districtName}】占比`,
                  type: 'line',
                  yAxisIndex: 1,
                  splitNumber: 5,
                  data: workInfo?.map((item) => item.rate),
                  lineStyle: {
                    color: '#F99090',
                    width: 4
                  },
                  itemStyle: {
                    color: '#F99090',
                  }
                }]}
                yAxisData={[
                  {
                    axisLabel: {
                      color: '#999999',
                      lineHeight: 22,
                      fontSize: 16,
                      fontWeight: 400
                    }
                  },
                  {
                    axisLabel: {
                      formatter: '{value}%',
                      color: '#999999',
                      lineHeight: 22,
                      fontSize: 16,
                      fontWeight: 400
                    }
                  }
                ]}
              /> : <></>}
            </div>

            <div className={styles['map']}>
              <PPTMap height={370} lnglat={lnglat} massData={massData} range={range}/>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
};

export default PageFour;
